import React, { useRef, useState, useCallback, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import CSUtil from '../util/CSUtil';

const CSDao = React.memo(() => {
    const dt = useRef(null);
    const [mDaoList, setDaoList] = useState(null);
    const [mDatasourceList, setDatasourceList] = useState(null);
    const [mTableList, setTableList] = useState(null);
    const [mSelectedDao, setSelectedDao] = useState(null);
    const [mSelectedDataSource, setSelectedDataSource] = useState(null);
    const [mSelectedTable, setSelecteTable] = useState(null);
    const [loading, setLoading] = useState(false);

    // Memoize handlers to prevent unnecessary re-renders
    const handleDaoChange = useCallback((lItem) => {
        setSelectedDao(lItem.value);
    }, []);

    const handleDataSourceChange = useCallback((lItem) => {
        setSelectedDataSource(lItem.value);
    }, []);

    const handleTableChange = useCallback((lItem) => {
        setSelecteTable(lItem.value);
    }, []);

    // Memoize dropdown options
    const dropdownOptions = useMemo(() => ({
        dao: mDaoList,
        dataSource: mDatasourceList,
        table: mTableList
    }), [mDaoList, mDatasourceList, mTableList]);

    // Memoize column definitions
    const columns = useMemo(() => [
        { field: 'column_name_', header: 'Column Name', sortable: true, style: { fontSize: '13px', width: '7em' } },
        { field: 'type_', header: 'Type', style: { fontSize: '13px', width: '3em' } },
        { field: 'alias_', header: 'Alias', style: { fontSize: '13px', width: '3em' } },
        { field: 'ai_name_', header: 'AI Name', style: { fontSize: '13px', width: '4em' } },
        { field: 'unique_flag_', header: 'Unique ?', style: { fontSize: '13px', width: '4em' } },
        { field: 'criteria_flag_', header: 'Criteria ?', style: { fontSize: '13px', width: '4em' } },
        { field: 'generation_flag_', header: 'Generation ?', style: { fontSize: '13px', width: '5em' } },
        { field: 'nullable_flag_', header: 'Nullable?', style: { fontSize: '13px', width: '4em' } }
    ], []);

    return (
        <>
            <div className="cs-dao-form-item-group" align="center">
                <div className="cs-dao-form-item">
                    <label htmlFor="ID_SERVICE_DAO" className="cs-dao-section-label">Dao Name</label>
                    <Dropdown
                        id="ID_SERVICE_DAO"
                        className="cs-dao-section-control"
                        options={dropdownOptions.dao}
                        optionLabel="dao_name_"
                        onChange={handleDaoChange}
                        disabled={loading}
                    />
                </div>

                <div className="cs-dao-form-item">
                    <label htmlFor="ID_SOLUTION_DATA_SOURCE" className="cs-dao-section-label">Data Source</label>
                    <Dropdown
                        id="ID_SOLUTION_DATA_SOURCE"
                        className="cs-dao-section-control"
                        options={dropdownOptions.dataSource}
                        optionLabel="name_"
                        onChange={handleDataSourceChange}
                        disabled={loading}
                    />
                </div>

                <div className="cs-dao-form-item">
                    <label htmlFor="ID_TABLE_NAME" className="cs-dao-section-label">Table Name</label>
                    <Dropdown
                        id="ID_TABLE_NAME"
                        className="cs-dao-section-control"
                        options={dropdownOptions.table}
                        optionLabel="name_"
                        onChange={handleTableChange}
                        disabled={loading}
                    />
                </div>

                <Button 
                    icon={CSUtil.mNameIconMap['PI_SEARCH']}
                    disabled={loading}
                    loading={loading}
                />
            </div>

            <DataTable 
                ref={dt} 
                style={{width: '100%'}}
                loading={loading}
                scrollable
                scrollHeight="400px"
                virtualScrollerOptions={{ itemSize: 46 }}
            >
                <Column selectionMode="multiple" style={{width:'2em'}}/>
                {columns.map(col => (
                    <Column 
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable={col.sortable}
                        style={col.style}
                    />
                ))}
            </DataTable>
        </>
    );
});

CSDao.displayName = 'CSDao';

export default CSDao;
